import React, { useState } from "react"
import Modal from "react-modal"
import classnames from "classnames"

import styles from "./Cirlce.module.scss"
import { useForm, ValidationError } from "@formspree/react"

const Cirlce = () => {
  const [modalIsOpen, setIsOpen] = useState(false)

  function openModal() {
    setIsOpen(true)
  }

  function afterOpenModal() {
    // references are now sync'd and can be accessed.
  }

  function closeModal() {
    setIsOpen(false)
  }
  return (
    <div
      className={classnames(styles.circle, {
        [styles.modalIsOpen]: modalIsOpen,
      })}
    >
      <svg
        viewBox="0 0 192 192"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        onClick={openModal}
      >
        <g clipPath="url(#clip0)">
          <circle
            cx="95.9355"
            cy="95.5304"
            r="58"
            transform="rotate(63.9197 95.9355 95.5304)"
            stroke="#309195"
            strokeWidth="20"
          />
          <path
            d="M46.2451 81.9062C47.3334 78.0987 45.4918 74.5208 41.8747 73.4869C38.2576 72.453 34.8033 74.5171 33.7149 78.3246C32.6216 82.1495 34.4855 85.715 38.0853 86.744C41.6852 87.7729 45.1518 85.731 46.2451 81.9062ZM43.8568 81.2235C43.2384 83.3869 41.1984 84.5636 38.8966 83.9056C36.5948 83.2477 35.4849 81.1707 36.1033 79.0073C36.7216 76.844 38.7616 75.6673 41.0634 76.3252C43.3652 76.9832 44.4751 79.0602 43.8568 81.2235Z"
            fill="white"
          />
          <path
            d="M51.5108 68.5243L55.1425 63.7785C57.1116 61.2055 57.0805 58.847 55.0792 57.3156C53.1637 55.8497 51.1391 56.3629 49.2903 58.7787L47.1682 61.5519L45.1097 59.9766L49.5291 54.2016L47.6851 52.7905L41.5045 60.8669L51.5108 68.5243ZM51.5566 64.9102L48.8692 62.8536L50.6414 60.5379C51.5712 59.3228 52.4704 59.0363 53.3567 59.7146C54.2572 60.4037 54.2367 61.408 53.3287 62.5944L51.5566 64.9102Z"
            fill="white"
          />
          <path
            d="M68.9189 51.757C70.7776 50.5876 71.8947 48.9492 72.1239 47.0825L69.6192 46.6167C69.4303 47.9051 68.7998 48.8972 67.7333 49.5682C65.7374 50.8238 63.4387 50.3136 62.1734 48.3024C60.9082 46.2913 61.4433 43.9982 63.4392 42.7426C64.5057 42.0716 65.673 41.9327 66.9066 42.305L67.571 39.8455C65.7986 39.2592 63.8381 39.557 61.9946 40.7167C58.6732 42.8063 57.6523 46.6596 59.6748 49.8744C61.6972 53.0891 65.6127 53.8369 68.9189 51.757Z"
            fill="white"
          />
          <path
            d="M85.8048 32.0297L83.8027 39.3606L79.144 33.4182L76.0955 34.0537L82.847 42.0972L82.7707 42.2602C82.4492 43.0995 81.969 43.5305 81.2642 43.6774C80.8941 43.7546 80.4705 43.7509 79.9829 43.7055L79.7475 46.0161C80.4935 46.1548 81.1925 46.1562 81.8445 46.0203C83.5009 45.675 84.7651 44.4186 85.3904 42.3025L88.6066 31.4457L85.8048 32.0297Z"
            fill="white"
          />
          <path
            d="M109.775 43.0621L111.403 32.9686L101.842 31.4266L101.073 35.2954C100.386 38.7583 99.5478 41.358 97.9221 41.1504L97.4245 41.0702L96.6129 45.9897L99.2784 46.4196L99.694 43.8429L108.473 45.2588L108.057 47.8355L110.723 48.2654L111.516 43.343L109.775 43.0621ZM103.571 35.9718L103.916 34.1678L108.181 34.8557L106.932 42.6036L101.37 41.7065C102.386 40.8311 103.037 38.6024 103.571 35.9718Z"
            fill="white"
          />
          <path
            d="M117.196 48.1049L119.566 49.5083L128.912 45.525L124.739 52.5719L127.217 54.0394L133.638 43.1981L131.283 41.8039L121.928 45.8027L126.111 38.7403L123.617 37.2636L117.196 48.1049Z"
            fill="white"
          />
          <path
            d="M148.891 58.7346L141.941 50.304L140.107 51.8154L142.661 54.9126L134.772 61.4161L136.604 63.6383L144.493 57.1349L147.057 60.246L148.891 58.7346Z"
            fill="white"
          />
          <path
            d="M152.669 75.4603L151.536 72.4634L155.408 70.9992L154.384 68.2885L142.598 72.7448L144.61 78.0651C145.755 81.0957 147.84 82.3857 150.551 81.3608C153.093 80.3995 153.745 78.3057 152.669 75.4603ZM146.573 77.1497L145.643 74.6915L149.516 73.2273L150.445 75.6855C150.98 77.0998 150.759 78.1453 149.463 78.6355C148.133 79.1384 147.101 78.5471 146.573 77.1497Z"
            fill="white"
          />
          <path
            d="M160.177 102.683L147.83 100.171L147.252 103.011L157.271 105.049L156.137 110.623L146.118 108.585L145.541 111.425L157.888 113.936L160.177 102.683Z"
            fill="white"
          />
          <path
            d="M150.236 130.206L153.161 125.602L142.527 118.844L140.963 121.306L143.895 123.169L142.534 125.311C140.728 128.152 141.073 130.866 143.442 132.372C145.828 133.887 148.431 133.046 150.236 130.206ZM144.626 126.449L145.9 124.443L149.592 126.789L148.318 128.794C147.362 130.299 146.196 130.624 145.026 129.88C143.871 129.147 143.67 127.953 144.626 126.449Z"
            fill="white"
          />
          <path
            d="M126.629 137.074C123.429 139.406 122.681 143.36 124.897 146.4C127.113 149.44 131.106 149.937 134.306 147.604C137.521 145.261 138.244 141.303 136.039 138.278C133.833 135.253 129.844 134.73 126.629 137.074ZM128.093 139.081C129.911 137.755 132.243 138.082 133.653 140.017C135.064 141.951 134.661 144.272 132.843 145.597C131.025 146.923 128.693 146.596 127.282 144.661C125.872 142.727 126.274 140.406 128.093 139.081Z"
            fill="white"
          />
          <path
            d="M112.031 147.358L112.793 150.172L107.146 151.702L107.739 153.891L113.386 152.361L114.101 155.002L107.707 156.734L108.319 158.992L117.51 156.503L114.216 144.341L104.799 146.892L105.411 149.15L112.031 147.358Z"
            fill="white"
          />
          <path
            d="M88.9622 147.033L85.6614 146.761L89.3602 153.604L84.7526 159.329L87.8203 159.582L91.5392 154.777L93.6202 154.948L93.202 160.025L96.0903 160.263L97.1246 147.705L94.2363 147.467L93.8197 152.526L91.8105 152.361L88.9622 147.033Z"
            fill="white"
          />
          <path
            d="M64.9613 152.335L74.94 156.785L75.9077 154.615L72.2418 152.98L76.4059 143.642L73.7756 142.469L69.6115 151.807L65.929 150.165L64.9613 152.335Z"
            fill="white"
          />
        </g>
        <circle
          cx="95.9713"
          cy="94.9722"
          r="10"
          transform="rotate(-126.108 95.9713 94.9722)"
          fill="#309195"
          className={styles.centralCircle}
        />
        <defs>
          <clipPath id="clip0">
            <rect
              width="137"
              height="137"
              fill="white"
              transform="translate(191.418 80.7344) rotate(126.108)"
            />
          </clipPath>
        </defs>
      </svg>
      <Modal
        isOpen={modalIsOpen}
        onAfterOpen={afterOpenModal}
        onRequestClose={closeModal}
        className={styles.modalWrapper}
        contentLabel="Обсудить проект"
      >
        <div onClick={closeModal} className={styles.closeModal}>
          <svg
            width="26"
            height="26"
            viewBox="0 0 26 26"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <rect
              x="0.335938"
              y="2.12109"
              width="3"
              height="33"
              transform="rotate(-45 0.335938 2.12109)"
              fill="#D1D9E3"
            />
            <rect
              x="23.3359"
              y="0.121094"
              width="3"
              height="33"
              transform="rotate(45 23.3359 0.121094)"
              fill="#D1D9E3"
            />
          </svg>
        </div>
        <Form closeModal={closeModal} />
      </Modal>
    </div>
  )
}

const Form = ({ closeModal }) => {
  const [fileName, setFileName] = useState("Прикрепить файл")
  const [state, handleSubmit] = useForm("xoqpgozg")
  if (state.succeeded) {
    return (
      <div className={classnames(styles.successPage)}>
        <div className={styles.successPageText}>
          <h2>Отлично!</h2>
          <span>
            Мы свяжемся с Вами в ближайшее время для более детального обсуждения
            проекта
          </span>
        </div>
        <div className={styles.buttonWrapper}>
          <button
            className={classnames(styles.button, styles.modalButton)}
            onClick={closeModal}
          >
            Окей, я жду
          </button>
        </div>
      </div>
    )
  }

  const handleChange = event => {
    const fileUploaded = event.target.files[0]
    setFileName(fileUploaded.name)
  }
  return (
    <div className={classnames(styles.modalContentWrapper)}>
      <h2>Обсудить проект</h2>
      <form onSubmit={handleSubmit} className={styles.modalForm}>
        <input
          className={styles.input}
          placeholder="Имя"
          type="text"
          required
        />
        <input
          className={styles.input}
          placeholder="Номер телефона"
          type="tel"
          name="phone"
          required
        />
        <input
          className={styles.input}
          placeholder="E-mail"
          name="E-mail"
          type="email"
          required
        />
        <input
          className={styles.input}
          placeholder="Компания"
          type="text"
          name="Компания"
        />
        <textarea
          placeholder="Опишите задачу"
          className={styles.textarea}
          name="Описание задачи"
          required
        />
        <input
          className={styles.invisibleInput}
          type="file"
          name="file"
          id="modalFileInput"
          onChange={handleChange}
        />
        <label className={styles.addFile} htmlFor="modalFileInput">
          <svg width="29" height="32" viewBox="0 0 29 32">
            <path
              id={styles.modalSkrepka}
              d="M5.24477 21.7157C4.95906 21.4305 4.73235 21.0917 4.5776 20.7188C4.42284 20.3459 4.34307 19.9462 4.34285 19.5425L4.34828 13.3975C4.34806 12.9936 4.42745 12.5936 4.58191 12.2204C4.73638 11.8472 4.96289 11.5081 5.2485 11.2225C5.5341 10.9369 5.8732 10.7104 6.24641 10.5559C6.61962 10.4015 7.01961 10.3221 7.42352 10.3223L22.7888 10.3223C23.5984 10.3414 24.3696 10.6715 24.9422 11.2441C25.5148 11.8168 25.845 12.5879 25.864 13.3975L25.8586 16.4673C25.8588 16.8712 25.7794 17.2711 25.625 17.6443C25.4705 18.0176 25.244 18.3566 24.9584 18.6422C24.6728 18.9279 24.3337 19.1544 23.9605 19.3088C23.5873 19.4633 23.1873 19.5427 22.7834 19.5425L10.4933 19.5425C9.67771 19.5425 8.89552 19.2185 8.3188 18.6417C7.74208 18.065 7.41808 17.2829 7.41808 16.4673C7.41808 15.6517 7.74208 14.8695 8.3188 14.2928C8.89552 13.7161 9.67771 13.3921 10.4933 13.3921L20.4851 13.3975L20.5068 14.9623H10.5205C10.1127 14.9623 9.72158 15.1243 9.43322 15.4126C9.14486 15.701 8.98287 16.0921 8.98287 16.4999C8.98287 16.9077 9.14486 17.2987 9.43322 17.5871C9.72158 17.8755 10.1127 18.0375 10.5205 18.0375L22.7888 18.0049C22.9908 18.005 23.1908 17.9653 23.3774 17.888C23.564 17.8108 23.7335 17.6976 23.8763 17.5548C24.0191 17.412 24.1324 17.2424 24.2096 17.0558C24.2868 16.8692 24.3265 16.6692 24.3264 16.4673L24.321 13.3975C24.3211 13.1955 24.2814 12.9956 24.2042 12.809C24.1269 12.6224 24.0137 12.4528 23.8709 12.31C23.7281 12.1672 23.5585 12.0539 23.3719 11.9767C23.1853 11.8995 22.9853 11.8598 22.7834 11.8599L7.41808 11.8599C7.21613 11.8598 7.01613 11.8995 6.82953 11.9767C6.64293 12.0539 6.47338 12.1672 6.33057 12.31C6.18777 12.4528 6.07451 12.6224 5.99728 12.809C5.92005 12.9956 5.88035 13.1955 5.88047 13.3975L5.8859 19.5425C5.88579 19.7444 5.92548 19.9444 6.00271 20.131C6.07995 20.3176 6.1932 20.4871 6.33601 20.6299C6.47881 20.7727 6.64836 20.886 6.83496 20.9632C7.02157 21.0405 7.22156 21.0802 7.42352 21.08L20.4634 21.08L20.4688 22.6068L7.42895 22.6068C7.02414 22.6094 6.6228 22.5321 6.24797 22.3791C5.87315 22.2262 5.53222 22.0008 5.24477 21.7157Z"
              fill="#fa5c45"
            />
          </svg>
          <div className={styles.textAdd}>{fileName}</div>
        </label>
        <button
          type="submit"
          disabled={state.submitting}
          className={styles.button}
        >
          ЗАКАЗАТЬ ЗВОНОК
        </button>
      </form>
    </div>
  )
}

export default Cirlce
